<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      @changeStatus="changeLeftSideStatus"
      @filtrate="filtrate"
      :_status="filterProp.status"
      :track_code="filterProp.trackCode"
      :weight_geq="filterProp.weightGeq"
      :weight_leq="filterProp.weightLeq"
      :transfer_code="filterProp.transferCode"
      :distributor_id="filterProp.distributorId"
      :distributor_name="filterProp.distributorName"
      :logistics="filterProp.logistics"
      :_tracks="tracks"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :_status="filterProp.status"
        :track_code="filterProp.trackCode"
        :weight_geq="filterProp.weightGeq"
        :weight_leq="filterProp.weightLeq"
        :transfer_code="filterProp.transferCode"
        :distributor_id="filterProp.distributorId"
        :distributor_name="filterProp.distributorName"
        :logistics="filterProp.logistics"
        @clearKey="clearKey"
        @exportOrder="exportOrder"
        :check_arr="checkArr"
      />
      <router-view
        :first_loading="firstLoading"
        :items="items"
        @cancel="cancel"
        @setPackage="setPackage"
        @openTransfer="openTransfer"
        :check_arr="checkArr"
        @changeChecked="changeChecked"
        @openLog="openLog"
        @openTransTrack="openTransTrack"
      ></router-view>
      <pagination
        v-if="!firstLoading"
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/transfer-abroad/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
    </div>
    <api-loading :show="loading"></api-loading>
    <confirmComponent
      :type="1"
      @del_index_i="cancelPackFn"
      :modal_id="cancelPack.modalId"
      :modal_title="cancelPack.title"
      :modal_text="cancelPack.text"
      :del_index="cancelPack.delIndex"
    ></confirmComponent>
    <confirmComponent
      :type="1"
      @del_index_i="setPackageFn"
      :modal_id="setPack.modalId"
      :modal_title="setPack.title"
      :modal_text="setPack.text"
      :del_index="setPack.delIndex"
    ></confirmComponent>
    <transfertModal
      :open="openTransferModal"
      :info="openTransferInfo"
      :type="openTransferType"
    ></transfertModal>
    <modalTransferLog :info="logInfo" :open="logOpen"></modalTransferLog>
    <ModalExpressLog
      :log_info="expressCodeLogInfo"
      :open="expressCodeLogOpen"
    ></ModalExpressLog>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import Modal from "@components/Modal";
import { confirmComponent } from "@components/components.js"; //删除确认
import { pagination } from "@components/pagination.js"; //分页
import transfertModal from "./modal-transfer.vue"; //分页
import modalTransferLog from "@views/transport/transfer-inland/modal-log.vue"; //
import ModalExpressLog from "./modal-express-log.vue";

export default {
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
    confirmComponent,
    transfertModal,
    modalTransferLog,
    ModalExpressLog,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      items: [],
      page: this.$route.params.page ? this.$route.params.page : 1,
      pageSizeSelect: [10, 20, 50],
      rowsPerPage: parseInt(store.get("transfer-abroad-rowsPerPage"))
        ? parseInt(store.get("transfer-abroad-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      cancelPack: {
        modalId: "modalCancel",
        title: this.$t("transfer.作废转运"),
        text: this.$t("transfer.确定要作废该转运包裹吗"),
        delIndex: "",
      },
      setPack: {
        modalId: "modalSetPack",
        title: this.$t("transfer.设为已打包"),
        text: this.$t("transfer.确定要设为已打包吗"),
        delIndex: "",
      },
      openTransferModal: Symbol(),
      openTransferInfo: "",
      openTransferType: "",
      filterProp: {
        status: "",
        weightGeq: "",
        weightLeq: "",
        trackCode: "",
        transferCode: "",
        distributorId: "",
        logistics: "",
        distributorName: "",
      },
      tracks: [],
      checkArr: [],
      logInfo: "",
      logOpen: Symbol(),
      expressCodeLogInfo: "",
      expressCodeLogOpen: Symbol(),
    };
  },
  computed: {},
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("transfer-abroad-rowsPerPage", this.rowsPerPage);
    },
  },
  methods: {
    openTransTrack(item) {
      this.expressCodeLogOpen = Symbol();
      this.expressCodeLogInfo = item;
      $("#modalLogisticsLog").modal("show");
    },
    openLog(i) {
      this.logInfo = this.items[i];
      this.logOpen = Symbol();
      $("#modalTransferLog").modal("show");
    },
    changeChecked(data) {
      this.checkArr = data;
    },
    exportOrder(type, flag) {
      console.log(type);
      let vm = this;
      let params = {};
      let url;
      if ($("#ifilePro").length == 0) {
        $("body").append(
          '<iframe id="ifilePro" style="display:none"></iframe>'
        );
      }
      let openDownload = (url) => {
        document.getElementById("ifilePro").src = url;
      };
      if (type == 1) {
        if (this.checkArr.length > 0) {
          params.ids = this.checkArr.join(",");
        }
      } else {
        if (!flag) {
          ShowTip(this.$t("transfer.请选择要导出的订单"), "danger");
          return;
        }
        if (this.totalCount > 100) {
          ShowTip(this.$t("transfer.导出的订单最多不能超过100条"), "danger");
          return;
        }
        params.distributorId = this.filterProp.distributorId;
        params.transCode = this.filterProp.transferCode;
        params.transTrackNumber = this.filterProp.trackCode;
        params.packageWeightGeq = this.filterProp.weightGeq;
        params.packageWeightLeq = this.filterProp.weightLeq;
        params.logistics = this.filterProp.logistics;
        params.status = this.filterProp.status;
      }
      this.loading = true;
      $.api_call(
        "api.DistributorPackage.exoportTransportBySupplier",
        params,
        (r) => {
          vm.loading = false;
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.addTask) {
              this.$store.commit("addTaskTimeFn", moment().unix());
              return;
            }
            url = r.Data.Results.url;
            openDownload(url);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(vm);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    clearKey(type) {
      if (type == "distributor") {
        this.filterProp.distributorName = this.filterProp.distributorId = "";
      } else {
        this.filterProp[type] = "";
      }

      this.toPage(1);
    },
    filtrate(
      status,
      name,
      id,
      weightGeq,
      weightLeq,
      trackCode,
      transferCode,
      keyLogistics
    ) {
      this.filterProp.status = status;
      this.filterProp.distributorName = name;
      this.filterProp.distributorId = id;
      this.filterProp.weightGeq = weightGeq;
      this.filterProp.weightLeq = weightLeq;
      this.filterProp.trackCode = trackCode;
      this.filterProp.transferCode = transferCode;
      this.filterProp.logistics = keyLogistics;
      //筛选都回第一页
      this.toPage(1);
    },
    openTransfer(item, type) {
      this.openTransferModal = Symbol();
      this.openTransferInfo = item;
      this.openTransferType = type;
      $("#modalTransfer").modal("show");
    },
    setPackage(item, type) {
      this.setPack.title =
        type == 2
          ? this.$t("transfer.设为已付款")
          : this.$t("transfer.设为已打包");
      this.setPack.text =
        type == 2
          ? this.$t("transfer.确定要设为已付款吗")
          : this.$t("transfer.确定要设为已打包吗");
      this.setPack.delIndex = item.id;
      $("#" + this.setPack.modalId).modal("show");
    },
    setPackageFn() {
      let tx =
        this.setPack.title == this.$t("transfer.设为已付款")
          ? this.$t("transfer.设为已付款成功")
          : this.$t("transfer.设为已打包成功");
      this.loading = true;
      $.api_call(
        "api.DistributorPackage.setTransportPackageStatus",
        {
          id: this.setPack.delIndex,
          status: this.setPack.title == this.$t("transfer.设为已付款") ? 2 : 3,
        },
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(tx, "success");
            $("#" + this.setPack.modalId).modal("hide");
            this.updateSuccess(this.setPack.delIndex);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    cancel(item) {
      this.cancelPack.delIndex = item.id;
      $("#" + this.cancelPack.modalId).modal("show");
    },
    cancelPackFn() {
      this.loading = true;
      $.api_call(
        "api.DistributorPackage.setTransportPackageStatus",
        {
          id: this.cancelPack.delIndex,
          status: 9,
        },
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("transfer.作废包裹成功"), "success");
            $("#" + this.cancelPack.modalId).modal("hide");
            this.updateSuccess(this.cancelPack.delIndex);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getList();
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.replace({ path: "/transfer-abroad/" + 1 });
      if (page == 1) {
        this.getList();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.replace({ path: "/transfer-abroad/" + num });
      if (page == num) {
        this.getList();
      }
      this.checkArr = [];
    },
    changeLeftSideStatus() {
      //改变左边栏状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    getList(s) {
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        distributorId: this.filterProp.distributorId,
        transCode: this.filterProp.transferCode,
        transTrackNumber: this.filterProp.trackCode,
        packageWeightGeq: this.filterProp.weightGeq,
        packageWeightLeq: this.filterProp.weightLeq,
        logistics: this.filterProp.logistics,
        status: this.filterProp.status,
      };
      $.api_call(
        "api.DistributorPackage.findTransportBySupplier",
        params,
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            this.items = r.Data.Results;
            this.totalPage = r.Data.Pagination.totalPage;
            this.totalCount = r.Data.Pagination.totalCount;
            if (!s) $("html,body").scrollTop(0);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    updateSuccess(id) {
      //成功后获取新数据
      $.api_call(
        "api.DistributorPackage.findTransportBySupplier",
        { id },
        (r) => {
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length == 0) return;
            let items = [];
            r.Data.Results.forEach((e) => {
              if (e.id == id) {
                items.push(e);
              }
            });
            this.items.forEach((e, i) => {
              if (e.id == items[0].id) {
                this.items.splice(i, 1, items[0]);
              }
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    getTrack() {
      $.api_call("api.InterShipping.findBySupplier", {}, (r) => {
        if (r.ErrorCode == "9999") {
          this.tracks = r.Data.Results;
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "transfer.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("transfer.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("transfer.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
        });
      }
    }
    this.getList();
    this.getTrack();
  },
};
</script>

<style lang="less" scoped>
.nav.nav-tabs {
  .nav-item {
    background-color: #fff;
    .nav-link {
      border-bottom-color: #ddd;
    }
    .nav-link:active,
    .nav-link.active {
      border-bottom: 1px solid transparent;
      color: inherit;
      background-color: #fff;
    }
    .nav-link:focus {
      color: #868ba1;
    }
    .nav-link:hover {
      background-color: #f0f0f0;
      color: #868ba1;
    }
    .nav-link.active:hover {
      background-color: #fff;
    }
  }
}
.tab-content {
  border: 1px #ddd solid;
  border-top: none;
  padding: 0 15px;
  .tab-container.active {
    display: block;
  }
  .tab-container {
    display: none;
  }
}

.modal-content {
  .sku-list {
    h3 {
      margin-bottom: 5px;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
    }
  }
  tbody {
    font-size: 12px;
  }
  .pro-info {
    display: flex;
    .img-wrap {
      margin-right: 5px;
      max-width: 60px;
      max-height: 60px;
      min-width: 60px;
      min-height: 60px;
      border: 1px #ddd solid;
      background-color: #fff;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .right {
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      max-width: 200px;
      min-width: 200px;
      line-height: 20px;
      .pro-attr {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .table-wrap {
    margin-bottom: 15px;
  }
  .new-return-bottom {
    border-top: 1px #ddd solid;
    padding: 15px 15px 0;
  }
  textarea {
    resize: none;
  }
}
.info-wrap {
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
.input-wrap {
  margin: 0 -15px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
</style>

